import {unByKey} from 'ol/Observable';
import StationsCatchmentsLayer from './StationsCatchmentsLayer';
import _AddOn from './_AddOn';
import './ki-catchment-info';
import {TopoJSON} from "ol/format";

export default class KiCatchmentsLayer extends _AddOn {
  static get properties() {
    return {
      catchments: { type: Array },
      catchmentsStyles: { type: Object },
      catchmentFeatures: { type: Array },
      currentCatchment: { type: Object }, // TODO id? station_no?
      visible: { type: String },
      name: { type: String },
    };
  }
  constructor() {
    super();
  }

  _afterMapCreated() {
    super._afterMapCreated();
    this._initHover();
  }

  _create() {
    console.log("_create of catchments layer start", new Date().getTime())
    this._createLayer()
    console.log("_create of catchments layer end", new Date().getTime())
  }

  _createLayer() {

    this.catchmentsLayer = new StationsCatchmentsLayer({
      catchments: this.catchments,
      catchmentsStyles: this.catchmentsStyles,
      currentCatchment: this.currentCatchment,
      visible: this.visible !== "false",
      name: this.name || 'Catchments',
      displayInLayerControl: true,
      group: 'Layers',
    });

    this.catchmentsLayer.setZIndex(parseInt(this.getAttribute("zindexlayer"), 10) || 50); // TODO use PropertyDefaultValue, check why atribute not works

    this.map.addLayer(this.catchmentsLayer);

    this.clickEvent = this.map.on('singleclick', evt => {
        let catchment;
        this.map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
          if (layer === this.catchmentsLayer) {
            if (feature && feature.getId()!==undefined) {
              catchment = feature.catchment
              // eslint-disable-next-line camelcase
              this.dispatchEvent(new CustomEvent('catchment-click', { detail: { value: feature.getId() } }));
            }
          }
        },
        { layerFilter: layer => layer === this.catchmentsLayer }
        );
        if (catchment) {
          return false; // skip rest listener;
        }
        return true;
      });

  }

  _initHover() {
    const element = document.createElement('ki-catchment-info');

    this.hoverEvent = this.map.on('pointermove', evt => {
      if (!this.catchmentsLayer) {
        return;
      }

      let hovering;

      this.map.forEachFeatureAtPixel(
        evt.pixel,
        feature => {
          if (feature && feature.catchment) {
            this.map.getTargetElement().style.cursor = 'pointer';
            element.catchment = feature.catchment;

            this.map.dispatchEvent({
              type: 'show-popup',
              detail: {
                coordinate: this.map.getCoordinateFromPixel(evt.pixel),
                element,
              },
            });
            // hovering
            if (!feature.__bak_style) {
              feature.__bak_style = feature.getStyle();
              feature.setStyle(this.catchmentsLayer._getHoverStyle(feature.catchment));
            }
            hovering = feature;
          }
        },
        { layerFilter: layer => layer === this.catchmentsLayer },
      );

      this.catchmentsLayer
        .getSource()
        .getFeatures()
        .forEach(f => {
          if (f !== hovering && f.__bak_style) {
            f.setStyle(f.__bak_style);
            f.__bak_style = null;
          }
        });

      if (hovering) {
        // eslint-disable-next-line consistent-return
        return false;
      }
    });
  }

  _tear() {
    this.map.removeLayer(this.catchmentsLayer);
    unByKey(this.clickEvent);
    unByKey(this.hoverEvent);
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has('catchmentsStyles') && this.catchmentsLayer) {
      this.catchmentsLayer.catchmentsStyles = this.catchmentsStyles
    }
    if (_changedProperties.has('catchmentFeatures') && this.catchmentsLayer) {
      this.catchmentsLayer.catchmentFeatures = this.catchmentFeatures
    }
    if (_changedProperties.has('catchments') && this.catchmentsLayer) {
      this.catchmentsLayer.catchments = this.catchments
    }

    if (this.catchmentsLayer && _changedProperties.has('currentCatchment')) {
      // TODO
      this.catchmentsLayer.highlight(this.currentCatchment);
    }
  }

/*  @autoRun(['currentCatchment', 'catchmentsLayer'])
  _autoFitToCatchment() {
    if (this.catchmentsLayer) {
      this.catchmentsLayer.currentCatchment = this.currentCatchment;
      if (this.currentCatchment && this.currentCatchment.feature) {
        const f = this.currentCatchment.feature;
        this.map.getView().animate({
          center: getCenter(f.getGeometry().getExtent()),
          maxZoom: 11,
          easing: inAndOut,
        });
      } else {
        this._autoFitCatchmentsExtent(true);
      }
    }
  }

  _autoFitCatchmentsExtent(force) {
    const source = this.catchmentsLayer.getSource();
    const { map } = this;
    if (source.getFeatures().length > 0) {
      const extent = source.getExtent();
      if (force || !isEqual(extent, this.__preExtent)) {
        // compare with previous extent, only fit when it's changed.
        // will not loss user operation.
        this.__preExtent = extent;
        map.getView().fit(extent, {
          duration: 1000,
          nearest: true,
          easing: inAndOut,
          padding: [50, 50, 50, 50],
          size: map.getSize(),
          maxZoom: 18,
        });
      }
    }
  } */
}

customElements.define('ki-catchments-layer', KiCatchmentsLayer);
